import React from 'react';

const BlurredPrice = ({ price, currency, className = "" }) => {
  return (
    <div className={`relative ${className}`}>
      {/* Strong blur to completely hide prices */}
      <div className="blur-md select-none">
        {price} {currency}
      </div>
      
      {/* Subtle overlay that maintains design consistency */}
      <div className="absolute inset-0 bg-current opacity-20 rounded-sm">
      </div>
    </div>
  );
};

export default BlurredPrice;
